// extracted by mini-css-extract-plugin
module.exports =  {"account":"account-LBUFP","identity":"identity-NcYNH","name":"name-scKhp","email":"email-DuM2Y","note":"note-UBtK_","sign-out":"sign-out-acHJl","error":"error-h3I5q"};